/**
 * Approved public display catalog generated from the server plan policy.
 * Historical offers remain displayable for existing subscriptions. New website
 * purchases use only the approved USD monthly offers.
 */

import {
  kStratifyPlanPolicyVersion,
  kStratifyPriceCatalogVersion,
  kStratifyPlanPolicyDisplayCatalog,
  kStratifyPlanPolicyDisplayOffers,
  stratifyPlanPolicyOfferForPlanCurrencyInterval,
  formatOfferPrice as formatGeneratedOfferPrice,
} from "./plan_policy_display.generated";

export const PLAN_POLICY_VERSION = kStratifyPlanPolicyVersion;
export const PRICE_CATALOG_VERSION = kStratifyPriceCatalogVersion;
function withPaperBotCaps(plan) {
  const catalogActivePaperBots = Number(plan.limits?.activePaperBots || 0);
  return {
    ...plan,
    limits: {
      ...plan.limits,
      catalogActivePaperBots,
      effectiveActivePaperBots: catalogActivePaperBots,
    },
  };
}

export const DISPLAY_PLANS = Object.freeze({
  free: Object.freeze(withPaperBotCaps(kStratifyPlanPolicyDisplayCatalog.free)),
  pro: Object.freeze(withPaperBotCaps(kStratifyPlanPolicyDisplayCatalog.pro)),
  elite: Object.freeze(withPaperBotCaps(kStratifyPlanPolicyDisplayCatalog.elite)),
});

export const DISPLAY_OFFERS = Object.freeze(kStratifyPlanPolicyDisplayOffers);

export function offerForPlanCurrencyInterval(planId, currency, interval) {
  return stratifyPlanPolicyOfferForPlanCurrencyInterval(planId, currency, interval);
}

export function newCheckoutOfferForPlan(planId) {
  return offerForPlanCurrencyInterval(planId, "usd", "month");
}

export function formatMoney(offer) {
  if (!offer) return "";
  const major = offer.unitAmountMinor / 100;
  const symbol = String(offer.currency).toLowerCase() === "cad" ? "CA$" : "$";
  return `${symbol}${major.toFixed(2)}`;
}

export function formatOfferPrice(offer) {
  if (!offer) return "";
  const period = offer.interval === "year" ? "/year" : "/month";
  return `${formatMoney(offer)} ${period}`;
}

export function paidPlanIds() {
  return ["pro", "elite"];
}

export { formatGeneratedOfferPrice };
